module.exports = __webpack_public_path__ + "static/media/core-intro-image.33884648.svg";